<fieldset>
  @if (label) {
    <label [raskRequired]="required">
      {{label}}
      @if (infoText) {
        <rask-info>{{infoText}}</rask-info>
      }
    </label>
  }
  <ng-select
    id="{{aid}}"
    bindLabel="{{bindLabel}}"
    bindValue="{{bindValue}}"
    [disabled]="disabled"
    [searchable]="false"
    [clearable]="clearable"
    [placeholder]="placeholder"
    [items]="items$ | async"
    [(ngModel)]="selected"
    [ngModelOptions]="{standalone: true}"
    [appendTo]="portalToBody ? 'body' : '#' + targetId"
    (change)="onSelectionChange($event)"
    (open)="onOpen($event)"
    (close)="onClose($event)">
    <ng-template ng-multi-label-tmp let-items="items">
      @for (item of items; track item) {
        <div class="ng-value">
          <span class="ng-value-label">{{viewSelectedFormatter(item)}}</span>
        </div>
      }
    </ng-template>
    <ng-template ng-option-tmp let-item="item" let-index="index">
      <span
      [ngClass]="{'disabled': itemDisabled(item), 'label-with-icon': iconClass}">{{viewFormatter(item)}}</span>
      @if (iconClass) {
        <rask-icon-button class="float-end" [icon]="iconClass"
        (click)="onIconClick($event, item)"></rask-icon-button>
      }
    </ng-template>
  </ng-select>

  @if (rule) {
    <rask-validation-message [hidden]="isPopupOpen" [rule]="rule"></rask-validation-message>
  }
</fieldset>
<div [id]="targetId"></div>